var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-chip',{attrs:{"small":"","rounded":"","color":_vm.statusColor(),"text-color":_vm.statusTextColor()}},[_vm._v("\n  "+_vm._s(_vm.statusText())+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }